export default __webpack_public_path__ + "static/media/Comentarios.42cd5457.svg";